module.exports = __webpack_public_path__ + "static/media/background.71bd9a35.png";